export const STATE = 'SELLING_POWER_STATE';  // use unique localstorage key

export const loadState = () => {
  try {
    const serializedState = localStorage.getItem(STATE);
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

export const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem(STATE, serializedState);
  } catch (e) {
    // ignore write errors.
  }
};



// WEBPACK FOOTER //
// ./src/config/localstorage.js